import styled from 'styled-components';

import colors from '../../styles/colors';

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border-left: 1px solid ${colors.shades.gamma1};
  background: ${colors.base.alpha};
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 16px;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.base.secondary2};
`;

const Subtitle = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: ${colors.shades.gamma2};
`;

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  background: ${colors.shades.gamma4};
  color: ${colors.base.secondary2};
  cursor: pointer;

  &:hover {
    background: ${colors.shades.gamma1};
  }
`;

const Tabs = styled.div`
  display: flex;
  gap: 8px;
  padding: 0 16px 12px;
`;

const Tab = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 16px;
  background: ${({ $active }) => ($active ? colors.shades.secondary5 : 'transparent')};
  color: ${({ $active }) => ($active ? colors.shades.secondary1 : colors.shades.gamma2)};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: ${({ $active }) => ($active ? colors.shades.secondary5 : colors.shades.gamma4)};
  }
`;

const BulkAction = styled.button`
  align-self: flex-start;
  margin: 0 16px 8px;
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: ${colors.shades.gamma4};
  color: ${colors.base.secondary2};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`;

const TruncationNotice = styled.div`
  padding: 0 16px 8px;
  font-size: 12px;
  color: ${colors.shades.gamma2};
`;

const RowList = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/*
  The row is a plain container: the thread it points at is opened by `RowMain`, which is a real
  button, and `Mark read` is a second real button beside it. Nesting one control inside another
  would leave the actions out of the tab order until the row was activated.
*/
const Row = styled.div`
  padding: 12px;
  border: 1px solid ${colors.shades.gamma1};
  border-radius: 12px;
  background: ${colors.base.alpha};

  &:hover {
    border-color: ${colors.shades.secondary7};
  }
`;

const RowMain = styled.button`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 0;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font: inherit;
`;

const RowTextGroup = styled.div`
  flex: 1;
  min-width: 0;
`;

const RowTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.base.secondary2};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const RowPreview = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: ${colors.shades.gamma2};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const UnreadBadge = styled.span`
  flex-shrink: 0;
  padding: 3px 10px;
  border-radius: 12px;
  background: ${colors.shades.secondary5};
  color: ${colors.shades.secondary1};
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
`;

const RowActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
`;

const RowAction = styled.button`
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: ${colors.shades.gamma4};
  color: ${colors.base.secondary2};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`;

const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 24px;
  text-align: center;
  color: ${colors.shades.gamma2};
`;

const EmptyTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.base.secondary2};
`;

export {
  Container,
  Header,
  Title,
  Subtitle,
  CloseButton,
  Tabs,
  Tab,
  BulkAction,
  TruncationNotice,
  RowList,
  Row,
  RowMain,
  RowTextGroup,
  RowTitle,
  RowPreview,
  UnreadBadge,
  RowActions,
  RowAction,
  EmptyState,
  EmptyTitle,
};
